export type SearchParamsType = {
  filter: {
    searchText: string;
    status: number;
  };
  sortOrder: string;
  sortField: string;
  pageNumber: number;
  pageSize: number;
};

export type SettingsTableDataType = {
  name: string;
  id: number;
  createdById: number;
  createdByDate: string;
  icon: string;
  parentId: number;
  parentName: string;
  status: number;
  ip: string | null;
  code: string;
  clinicId: number;
  page: string;
  usermenuId: number | null;
  
};

export type SettingsDataType = {
  id: number |null ;
  name: string;
  code: string;
  clinicId: number;
  status: number;
  createdByDate: string;
  createdById: number;
  icon: string;
  ip: string;
  page: string;
  parentId: number;
  userMenuId: number | null
};

export type MenuParentType = {
  name: string;
  code: string;
  id: number;
};

export type IconsType = {
  icon:string
}

export type SaveResponseType = {};

export type SettingsFormDataType = {
  name: string;
  code: string;
  status: number;
  icon: IconsType | null;
  page: string;
  parent: MenuParentType | null;
  userMenuId: number | null
};

export const initialFormData: SettingsFormDataType = {
  name: "",
  code: "",
  status: 1,
  icon: null,
  page: "",
  parent: null,
  userMenuId :null
};
